var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.293 4.293a1 1 0 0 1 1.414 0L9 11.586l7.293-7.293a1 1 0 1 1 1.414 1.414l-7.646 7.647a1.5 1.5 0 0 1-2.122 0L.293 5.707a1 1 0 0 1 0-1.414Z",
  clipRule: "evenodd"
})));
export default SvgIconArrowDown;